import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { createScheduleTypes } from 'projectSpecific/sports/cnr/reducers/CreateSportsReducer';
import { usePlayoffSchedule } from 'projectSpecific/sports/useHelpers/usePlayoffSchedule';
import { useTournamentData } from 'projectSpecific/sports/useHelpers/useTournamentData';
import { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Button, Segment } from 'semantic-ui-react';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import NoData from '../../../../global/components/alerts/NoData';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { tournamentTypes } from '../../cnr/reducers/SportsTournamentReducer';
import PlayoffMatchesProvider from 'projectSpecific/sports/cnr/contexts/PlayoffMatchesProvider';
import PlayoffBracket from '../../elements/matches/PlayoffBracket';
import PlayoffBrackets from '../../elements/matches/PlayoffBrackets';
import { CreatePlayoffContext } from '../CreatePlayoff';
import { CreateSportsContext } from '../CreateSports';

const sidebarType = 'createTournament'

/**
 * 
 * @param {object} props 
 * @returns 
 */
const CreateTournamentSchedule = (props) => {

  const {
    createScheduleType,
    tournamentType,
    componentContexts,
    asGrid,
    tournament: pageTournament,
    _tournamentName,
    teams_level,
  } = props ?? {}

  const upn = usePageNavigation()

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { playoff_info: playoff_info_season, _sportSeasonSettings } = sportsSeason_state ?? {}
  const { usePlayoffBrackets } = _sportSeasonSettings ?? {}
  const { playoffTournaments } = playoff_info_season ?? {}

  // createSportsContext and createPlayoffContext are in the same tree 
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { playoff_info: playoff_info_create } = createSports_state ?? {}

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_matchInfo, playoff_info: playoff_info_playoff, playoffGroupKey } = createPlayoff_state ?? {}
  const { tournaments: tournaments_playoff } = playoff_matchInfo ?? {}

  const playoffInfo = playoff_info_playoff ? playoff_info_playoff : playoff_info_create
  const { playoffLevelTeams, playoffLevel, playoffTeamsSorted, plts } = playoffInfo ?? {}

  const _plts = plts?.[playoffGroupKey]

  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInit, setInits } = sidebar_handlers ?? {}

  const [selectedLevel, setSelectedLevel] = useState()

  // ms_rounds playoffs etc.
  // ms_tournaments 4A, 3A, etc.
  // ms_pools R16, QF, SF, F


  const { ms_tournaments, ms_pools } = sidebar_items ?? {}
  let { ms_rounds } = sidebar_items ?? {}

  const { selected: selected_tournament } = ms_tournaments ?? {}
  const { item: itemTab_tournament } = selected_tournament ?? {}

  const itemTab_tournamentCurrent = selectedLevel || itemTab_tournament || playoffLevel || _tournamentName

  const { selected: selected_pool } = ms_pools ?? {}
  const { item: itemTab_pool } = selected_pool ?? {}

  if (tournamentType === tournamentTypes.existingPlayoff) { ms_rounds = { selected: { item: 'playoffs' } } }

  const { selected: selectedTab_round } = ms_rounds ?? {}
  const { item: item_round } = selectedTab_round ?? {}

  const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled }

  // componentContexts
  const { uiItemContext } = componentContexts ?? {}
  const { item_state } = uiItemContext ?? {}
  const { viewItem } = item_state ?? {}

  const { createTournamentInfo } = useTournamentData()
  const { getPoolsAndRounds } = usePlayoffSchedule({ tournamentType, pageTournament })

  const handle_selectLevel = (sl) => setSelectedLevel(sl)

  // rounds - playoffs
  // tournaments - 4A, 3A, 2A, 1A
  // pools - R32, R16, QF, SF, F
  // schedule - schedule, ?results 

  useEffect(() => {
    if (tournamentType === tournamentTypes.newPlayoff) {
      createTournamentInfo({ forPlayoff: true, state: createPlayoff_state, callback: createPlayoff_handlers.handleAmmend_playoffMatchInfo })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_plts, playoffLevelTeams]);

  // sets the tournaments 
  const tournaments = useMemo(() => {
    switch (tournamentType) {
      case tournamentTypes.tournament: {
        const { name: tournamentName } = pageTournament ?? {};
        return {
          someTournament: pageTournament
        }
      }

      case tournamentTypes.newPlayoff:
        return tournaments_playoff;
      default:
        return playoffTournaments;
    }
  }, [playoffTournaments, tournaments_playoff, pageTournament])


  const noData = !tournaments || Object.keys(tournaments).length === 0;

  const getInits_tournaments = (rounds, pools) => {
    let _ins = []
    switch (tournamentType) {
      case tournamentTypes.existingPlayoff:
        const tks = _.keys(tournaments).sort().reverse()
        if (!selectedLevel) {
          setSelectedLevel(tks[0])
        }
        _ins = [{ smt: sidebarMenuTypes.one, items: tks, currents, as: 'tournaments', ..._initProps }]
        if (usePlayoffBrackets) {
          _ins.push({ smt: sidebarMenuTypes.two, items: pools ? Object.values(pools) : [], currents, as: 'pools', useStartCase: true, ..._initProps })
        }
        break;
      default:
        _ins = [
          { smt: sidebarMenuTypes.one, items: rounds ? Object.keys(rounds) : [], currents, as: 'rounds', useStartCase: true, ..._initProps, hidden: true },
          { smt: sidebarMenuTypes.two, items: playoffLevel ? [] : Object.keys(tournaments).sort().reverse(), currents, as: 'tournaments', ..._initProps },
        ]
        if (usePlayoffBrackets) {
          _ins.push({ smt: sidebarMenuTypes.three, items: pools ? Object.values(pools) : [], currents, as: 'pools', useStartCase: true, ..._initProps })
        }
    }
    return _ins
  }

  const { rounds, poolz } = useMemo(() => {
    if (_.isEmpty(tournaments)) { return { rounds: {}, poolz: [] } }
    if (tournaments && itemTab_tournament) {
      const { rounds: _rounds, poolz: _poolz } = getPoolsAndRounds({ tournamentItem: itemTab_tournament })
      return { rounds: _rounds, poolz: _poolz }
    } else if (itemTab_tournamentCurrent) {
      if (pageTournament) {
        return { rounds: pageTournament.rounds, poolz: pageTournament?.rounds?.playoffs?.pools }
      }
      const { rounds: _rounds, poolz: _poolz } = getPoolsAndRounds({ tournamentItem: itemTab_tournamentCurrent })
      return { rounds: _rounds, poolz: _poolz }
    } else {
      return { rounds: {}, poolz: [] }
    }
  }, [tournaments, itemTab_tournamentCurrent, itemTab_tournament])

  useEffect(() => {
    if (tournaments && rounds && poolz) {
      const _inits = getInits_tournaments(rounds, poolz)
      setInits(_inits)
    } else if (itemTab_tournamentCurrent && item_round) {
      switch (tournamentType) {
        case tournamentTypes.existingPlayoff:
          setInit({ smt: sidebarMenuTypes.two, items: poolz ? Object.values(poolz) : [], currents, as: 'pools', useStartCase: true, ..._initProps, hidden: usePlayoffBrackets })
          break;
        default:
          setInit({ smt: sidebarMenuTypes.three, items: poolz ? Object.values(poolz) : [], currents, as: 'pools', useStartCase: true, ..._initProps, hidden: usePlayoffBrackets })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [rounds, poolz]);

  const handleMatchClick = (clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex) => {
    if (itemKey) upn.handleNav_item(clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex)
  }

  const playoffBrackets = (round) => <PlayoffBrackets
    round={round}
    roundItem={ms_rounds.selected.item}
    componentContexts={componentContexts}
    tournamentType={tournamentType}
    asGrid={asGrid}
    item_tournament={itemTab_tournamentCurrent}
  />

  const selectedMatches = () => {

    let allow = false

    switch (tournamentType) {
      case tournamentTypes.existingPlayoff:
        if (tournaments && ms_tournaments && ms_pools) {
          allow = true
        }
      default:
        if (tournaments && ms_tournaments && ms_rounds && ms_pools) {
          allow = true
        }
    }

    if (!allow) return <Segment basic>{tournamentType}</Segment>

    const tournament = tournaments[itemTab_tournamentCurrent]
    const { rounds } = tournament ?? {}
    const round = rounds && ms_rounds ? rounds[item_round] : null

    if (usePlayoffBrackets) {
      switch (tournamentType) {
        case tournamentTypes.existingPlayoff:
        case tournamentTypes.tournament:
          return playoffBrackets(round)
        default:
          return playoffTeamsSorted ? playoffBrackets(round) : <div className='hwcc'>Pending Seed Sorting</div>
      }
    } else {
      const { pools } = round ?? {}
      const pool = pools ? pools[itemTab_pool] : null
      const { matches } = pool ?? {}
      const mss = <PlayoffMatchesProvider
        tournamentType={tournamentType}
        poolMatches={matches}
        pools={pools}
        poolKey={itemTab_pool}
        isTournament={true}
        viewItem={viewItem}
        handleMatchClick={handleMatchClick}
      >
        {asGrid && <PlayoffBracket pool={pool} item_tournament={itemTab_tournamentCurrent} />}
      </PlayoffMatchesProvider>
      return mss
    }
  }

  const levelHeader = useMemo(() => {
    if (ms_tournaments?.items) {
      const mis = _.map(ms_tournaments.items, ti => (
        <Button
          color={selectedLevel === ti ? 'blue' : null}
          className={selectedLevel === ti ? 'btn-sel' : null}
          onClick={() => handle_selectLevel(ti)}>{ti}
        </Button>))
      return <div className='ms-button-group swr'>
        <Button.Group size='mini' className='swipe-tab-container'>
          {mis}
        </Button.Group>
      </div>
    }
  }, [selectedLevel])


  const wrapper = () => <Wrapper
    header={levelHeader}
    content={selectedMatches()}
    noMid={false}
    wrapperType={wrapperTypes.paddedContent}
  ></Wrapper>

  if (noData) {
    return <NoData fullCaption={'No Tournament Playoff Schedule'} />
  } else {
    if (createScheduleType === createScheduleTypes.playoff) {
      return selectedMatches()
    } else {
      return wrapper()
    }
  }
}

export default CreateTournamentSchedule